import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PageTitleService } from '../../../shared/page-title.service';

@Component({
    selector: 'app-content-header',
    templateUrl: './content-header.component.html',
    styleUrls: ['./content-header.component.scss'],
    host: { '[style.display]': "'none'" },
    standalone: false
})
export class ContentHeaderComponent implements OnInit, OnChanges {
  @Input('icon') icon: any;
  @Input('title') title: any;
  @Input('desc') desc: any;
  @Input('hideBreadcrumb') hideBreadcrumb: boolean = false;
  @Input('hasBgImage') hasBgImage: boolean = false;
  @Input('class') class: any;
  /** When false, content-header will not update the global PageTitleService. */
  @Input() updatePageTitle: boolean = true;

  constructor(private pageTitleService: PageTitleService) {}

  ngOnInit() {
    if (this.updatePageTitle && this.title != null) {
      this.deferSetTitle(this.title);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.updatePageTitle && changes['title'] && this.title != null) {
      this.deferSetTitle(this.title);
    }
  }

  /** Defers setting the page title to the next tick to avoid ExpressionChangedAfterItHasBeenCheckedError. */
  private deferSetTitle(title: string): void {
    setTimeout(() => this.pageTitleService.setTitle(title), 0);
  }
}
